import { InjectionToken } from '@angular/core';

// if set to true, operations for the entity-type "NoEntity" will be visible even if there is a selection.
// this is due to backwards compatibility reasons to not break use-cases where operations should be in the magic-button but not in the context menu
export const MAGIC_BUTTON_NO_ENTITY_MEANS_ANY_OR_NO_ENTITY = new InjectionToken<boolean>('MAGIC_BUTTON_NO_ENTITY_MEANS_ANY_OR_NO_ENTITY');
